// CommonModal.tsx
import { Modal } from "antd";

interface AntCommonModalProps {
  open: boolean;
  onCancel?: () => void;
  onOk?: () => void;
  title: React.ReactNode;
  content?: React.ReactNode;
  okText?: string;
  cancelText?: string;
  children?: React.ReactNode;
  confirmLoading?: boolean;
  footer?: React.ReactNode;
  destroyOnClose?: boolean;
  width?: number | string;
  maskClosable?: boolean;
  keyboard?: boolean;
  bodyStyle?: React.CSSProperties;
  onClose?: () => void;
  /** Wraps the entire modal DOM (use for ConfigProvider so portaled content inherits theme). */
  modalRender?: (originNode: React.ReactNode) => React.ReactNode;
}

const CommonModal: React.FC<AntCommonModalProps> = ({
  open,
  onCancel,
  onOk,
  title,
  okText = "OK",
  cancelText = "Cancel",
  children,
  confirmLoading = false,
  footer,
  destroyOnClose = false,
  width = 500,
  maskClosable = false,
  bodyStyle,
  keyboard = false,
  modalRender,
}) => {
  return (
    <Modal
      title={title}
      open={open}
      onCancel={onCancel}
      onOk={onOk}
      okText={okText}
      cancelText={cancelText}
      confirmLoading={confirmLoading}
      footer={footer}
      destroyOnClose={destroyOnClose}
      width={width}
      maskClosable={maskClosable}
      keyboard={keyboard}
      closable
      centered
      styles={{ body: bodyStyle }}
      modalRender={modalRender}
    >
      {children} {/* Render children */}
    </Modal>
  );
};

export default CommonModal;
